module.exports = __webpack_public_path__ + "img/SNM.90cf9f6a.svg";